import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "regenerator-runtime/runtime.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable camelcase */
import React, { useRef, useState, useEffect } from 'react';
import { Row, Col, Table, Button, Dropdown, useUrlParams, useIsMounted, useUser, showSuccess, useWindowSize } from 'components';
import { showApiError } from 'utils';
import { getAllPayments, reportPayments } from 'services';
import { PAYMENT_COLLECTION_STATUS } from 'enums';
import { tableWrap } from 'styles';
import { pendingReportColumns } from './config';
import ReportPaymentsModal from './ReportPaymentsModal';
import { tableHeaderContainer, footerContainer } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var PendingReportPayments = function PendingReportPayments() {
  var _offices$;

  var _useUser = useUser(),
      roleAdditionalData = _useUser.roleAdditionalData;

  var _useWindowSize = useWindowSize(),
      windowWidth = _useWindowSize.width;

  var _useUrlParams = useUrlParams(),
      urlQueryParams = _useUrlParams.urlQueryParams;

  var tableRef = useRef();
  var modalRef = useRef();

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      selectedPayments = _useState2[0],
      setSelectedPayments = _useState2[1];

  var offices = (roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.offices) || [];

  var _useState3 = useState(urlQueryParams.office || (offices.length === 1 ? (_offices$ = offices[0]) === null || _offices$ === void 0 ? void 0 : _offices$.id : null)),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedOffice = _useState4[0],
      setSelectedOffice = _useState4[1];

  var isMounted = useIsMounted();
  useEffect(function () {
    var _offices$2;

    // Auto-select if only one office
    if (!selectedOffice && offices.length === 1) setSelectedOffice((_offices$2 = offices[0]) === null || _offices$2 === void 0 ? void 0 : _offices$2.id);
  }, [offices]);
  useEffect(function () {
    if (isMounted.current && selectedOffice) {
      var _tableRef$current;

      (_tableRef$current = tableRef.current) === null || _tableRef$current === void 0 ? void 0 : _tableRef$current.getData({
        office: selectedOffice,
        collectionStatus: PAYMENT_COLLECTION_STATUS.collected_from_client
      });
    }
  }, [selectedOffice]);

  var fetchAllPayments = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(tableOptions) {
      var _yield$getAllPayments, _yield$getAllPayments2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (tableOptions.office) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", [{
                data: [],
                total: 0
              }, null]);

            case 2:
              _context.next = 4;
              return getAllPayments(_objectSpread(_objectSpread({}, tableOptions), {}, {
                collectionStatus: PAYMENT_COLLECTION_STATUS.collected_from_client
              }));

            case 4:
              _yield$getAllPayments = _context.sent;
              _yield$getAllPayments2 = _slicedToArray(_yield$getAllPayments, 2);
              res = _yield$getAllPayments2[0];
              err = _yield$getAllPayments2[1];

              if (!err) {
                _context.next = 11;
                break;
              }

              showApiError(err);
              return _context.abrupt("return", [null, err]);

            case 11:
              return _context.abrupt("return", [res, null]);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchAllPayments(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var handleOfficeChange = function handleOfficeChange(value) {
    var _tableRef$current2;

    setSelectedOffice(value);
    (_tableRef$current2 = tableRef.current) === null || _tableRef$current2 === void 0 ? void 0 : _tableRef$current2.getData({
      office: value,
      collectionStatus: PAYMENT_COLLECTION_STATUS.collected_from_client
    });
  };

  var handleSelect = function handleSelect(payments) {
    setSelectedPayments(payments);
  };

  var handleReportClick = function handleReportClick() {
    var _modalRef$current;

    if (selectedPayments.length === 0) return;
    (_modalRef$current = modalRef.current) === null || _modalRef$current === void 0 ? void 0 : _modalRef$current.open();
  };

  var handleConfirmReport = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _modalRef$current2, _tableRef$current3;

      var paymentIds, _yield$reportPayments, _yield$reportPayments2, err;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              paymentIds = selectedPayments.map(function (p) {
                return p.id;
              });
              _context2.next = 3;
              return reportPayments(paymentIds);

            case 3:
              _yield$reportPayments = _context2.sent;
              _yield$reportPayments2 = _slicedToArray(_yield$reportPayments, 2);
              err = _yield$reportPayments2[1];

              if (!err) {
                _context2.next = 8;
                break;
              }

              return _context2.abrupt("return", showApiError(err));

            case 8:
              showSuccess('Плащанията са отчетени успешно!');
              (_modalRef$current2 = modalRef.current) === null || _modalRef$current2 === void 0 ? void 0 : _modalRef$current2.close();
              setSelectedPayments([]);
              (_tableRef$current3 = tableRef.current) === null || _tableRef$current3 === void 0 ? void 0 : _tableRef$current3.getData({
                office: selectedOffice,
                collectionStatus: PAYMENT_COLLECTION_STATUS.collected_from_client
              });

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleConfirmReport() {
      return _ref2.apply(this, arguments);
    };
  }();

  var filterBar = function filterBar() {
    return ___EmotionJSX("section", {
      css: tableHeaderContainer
    }, ___EmotionJSX(Row, {
      horizontalGap: 16,
      verticalGap: 8
    }, ___EmotionJSX(Col, {
      sm: 12,
      md: 4
    }, ___EmotionJSX(Dropdown, {
      small: true,
      withSearch: true,
      placeholder: "\u041E\u0444\u0438\u0441 *",
      displayKey: "name",
      uniqueKey: "id",
      value: selectedOffice,
      options: offices,
      onChange: handleOfficeChange,
      mapValue: function mapValue(val) {
        return val === null || val === void 0 ? void 0 : val.id;
      }
    })), !selectedOffice && ___EmotionJSX(Col, {
      sm: 12,
      md: 8,
      displayFlex: true,
      align: "center"
    }, ___EmotionJSX("p", {
      style: {
        color: '#666',
        fontStyle: 'italic'
      }
    }, "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u043E\u0444\u0438\u0441"))));
  };

  var footerBar = function footerBar() {
    return ___EmotionJSX("div", {
      css: footerContainer
    }, ___EmotionJSX(Button, {
      type: "primary",
      onClick: handleReportClick,
      disabled: selectedPayments.length === 0
    }, "\u041E\u0442\u0447\u0435\u0442\u0438 \u043F\u043B\u0430\u0449\u0430\u043D\u0438\u044F\u0442\u0430 (", selectedPayments.length, ")"));
  };

  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX("div", {
    css: tableWrap
  }, ___EmotionJSX(Table, {
    hasPagination: true,
    hasSelection: true,
    ref: tableRef,
    getDataMethod: fetchAllPayments,
    columns: pendingReportColumns(windowWidth),
    emptyMessage: "\u041D\u044F\u043C\u0430 \u043D\u0430\u043C\u0435\u0440\u0435\u043D\u0438 \u0447\u0430\u043A\u0430\u0449\u0438 \u043F\u043B\u0430\u0449\u0430\u043D\u0438\u044F \u0437\u0430 \u0438\u0437\u0431\u0440\u0430\u043D\u0438\u044F \u043E\u0444\u0438\u0441",
    filterBar: filterBar,
    footerBar: footerBar,
    onSelect: handleSelect,
    margin: "0 2em",
    pageSize: 20
  })), ___EmotionJSX(ReportPaymentsModal, {
    modalRef: modalRef,
    selectedPayments: selectedPayments,
    onConfirm: handleConfirmReport,
    onClose: function onClose() {}
  }));
};

export default PendingReportPayments;